<template>
  <div class="AtlasEmbeddedView">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

import {
  EmbeddableContextInjectionKey,
  parseQueryFromEmbeddedView,
} from '../../embedding';

const GeographyQueryParam = {
  GEO_CODE: 'geo',
  GEO_CODE_COMPARE: 'geo_compare',
};

export default defineComponent({
  name: 'atlas-embedded-view',

  provide() {
    return {
      [EmbeddableContextInjectionKey]: {
        query: parseQueryFromEmbeddedView(this.$route.query),
      },
    };
  },

  methods: {
    ...mapActions({
      initIndicatorGeography: 'indicator/initGeography',
    }),

    handleIndicatorGeographyFromRouteQuery(currentRoute) {
      const geoCode = currentRoute.query[GeographyQueryParam.GEO_CODE];

      this.initIndicatorGeography({ geoCode });
    },
  },

  mounted() {
    const { currentRoute } = this.$router;

    this.handleIndicatorGeographyFromRouteQuery(currentRoute.value);
  },
});
</script>
